<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>My Travel Defaults</h3>
    </div>
    <div class="col-xs-12 col-md-6  vcenter-right">
      <div>
      </div>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />  <div class="row">
    <div class="col-xs-11">
      <aims-form [editable]="true" [cols]="4" [header]="''" [spaceRows]="true">
        <aims-fc [labelColSize]="5" [controlColSize]="7">
          <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
            <input matInput
                 #aimsControl="ngModel"
                 id="travelWeight"
                 type="text"
                 name="Travel Weight"
                 [(ngModel)]="travelWeight"
                 (change)="saveTravelWeight()" />
          </mat-form-field>
        </aims-fc>

      </aims-form> <br/>
      <aims-form [editable]="true" [cols]="1" [header]="'Default Baggage'" [spaceRows]="true">
<aims-fc>
        <aims-common-table
            id="trvl-pref-table"
            [dataSource]="travelBagDefaults | async"
            [header]="tableHeader"
            [permissions]="tablePermissions"
            [pageSize]="10"
            [addRowInitialObject]="defaultBag"
            (rowAdded)="handleRowUpdate($event)"
            (rowUpdated)="handleRowUpdate($event)"
            (rowDeleted)="handleRowDelete($event)"
            [stickyHeader]="true">

          <aims-common-table-dynamic-row id="travelRequestBagTypeId">
            <ng-template viewMode let-element >
              {{ element.travelRequestBagTypeId | getText:'travelRequestBagTypeId':'travelRequestBagType':travelRequestBagTypeValues | async }}
            </ng-template>

            <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                <mat-select style="width: 100px" [formControl]="dynamicControl" name="travelRequestBagTypeId" required>
                  <mat-option *ngFor="let val of travelRequestBagTypeValues | async" [value]="val.travelRequestBagTypeId">
                    {{val.travelRequestBagType }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="dynamicControl.hasError('required')">Required</mat-error>
              </mat-form-field>
            </ng-template>

            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of travelRequestBagTypeValues | async" [value]="val.travelRequestBagTypeId">
                    {{val.travelRequestBagType }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>
        </aims-common-table>

      </aims-fc>
      </aims-form>

    </div>
  </div>
</div>
